.tabs {
  display: flex;
  gap: 2px;
  margin-bottom: var(--sp-6);
  border-bottom: 1px solid var(--line);
  overflow-x: auto;
}
.tab {
  margin-bottom: -1px;
  padding: 9px 15px;
  border: none;
  border-bottom: 2px solid transparent;
  background: none;
  color: var(--sage);
  font-size: 11.5px;
  font-weight: 600;
  white-space: nowrap;
  cursor: pointer;
  transition: var(--transition);
}
.tab:hover:not(:disabled) {
  color: var(--text);
}
.tab:disabled {
  opacity: 0.4;
  cursor: not-allowed;
}
.active {
  border-bottom-color: var(--magenta);
  color: var(--magenta);
}
.count {
  margin-left: 5px;
  color: var(--text2);
  font-weight: 400;
}
